import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'antd'
import { useTranslation } from 'react-i18next'
import WorkList from '../JobList'

const Exp = () => {

    const {t} = useTranslation()

    return (
        <>
            <Container>
                <Row justify='center'>
                    <Col>
                        <h2 style={{textAlign: 'center'}}>{t('Experiencia')}</h2>
                    </Col>
                </Row>
                <Row justify='center' style={{width: '100%', padding: '30px 0'}}>
                    <WorkList displayed={3} col={6}/>
                </Row>
                <Row justify='center'>
                    <Col>
                        <ButtonMore onClick={()=>{window.location.pathname = '/trabalhos'}}>
                            Ver mais
                        </ButtonMore>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Exp;

const Container = styled.div`
    background-color: #010008;
    padding: 40px 0;
    & *{
        color: #f0f2f5;
        font-family: 'Share Tech Mono', monospace;
    }
    & h2 {
        font-size: 30px;
    }
`

const ButtonMore = styled.button`
    color: black!important;
    padding: 8px 50px;
    border-radius: 10px;
    box-sizing: border-box;
    border: 1px solid #010008;
    cursor: pointer;
    transition: all .3s;

    &:hover {
        background: #010008;
        border: 1px solid #f0f2f5;
        color: #f0f2f5!important;
        box-shadow: 0px 0px 10px #f0f2f5;
    }
`